var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCameraSync(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 73 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.7 7.333H54.75L47.45 0h-21.9l-7.3 7.333H7.3c-4.015 0-7.3 3.3-7.3 7.334v44c0 1.945.77 3.81 2.138 5.185A7.283 7.283 0 007.3 66h58.4c4.051 0 7.3-3.263 7.3-7.333v-44a7.35 7.35 0 00-2.138-5.186A7.283 7.283 0 0065.7 7.333zM10.95 33h7.665a18.37 18.37 0 012.755-6.6 18.28 18.28 0 015.061-5.035A18.156 18.156 0 0140.15 18.7c2.774.55 5.22 1.797 7.3 3.3l-5.256 5.317a10.681 10.681 0 00-5.694-1.65c-4.599 0-8.76 2.933-10.293 7.333h6.643L21.9 44 10.95 33zm43.472 7.333c-2.008 9.937-11.644 16.317-21.572 14.3a19.666 19.666 0 01-7.3-3.3l5.256-5.316c1.679 1.026 3.613 1.65 5.694 1.65 4.636 0 8.797-2.934 10.33-7.334h-6.68l10.95-11 10.95 11h-7.628z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSync);
export default ForwardRef;